import { api } from './api';

export interface Account {
  id: string;
  workspaceId: string;
  legalName: string;
  jpCorpNumber: string | null;
  domain: string | null;
  countryCode: string | null;
  industry: string | null;
  employeeBand: string | null;
  revenueBand: string | null;
  foundedYear: number | null;
  hqAddress: string | null;
  techStack: string[];
  ownerUserId: string | null;
  healthScore: number | null;
  createdAt: string;
  updatedAt: string;
}

export const accountsApi = {
  list: async (params: { workspaceId: string; country?: string; search?: string; limit?: number; offset?: number }) => {
    const r = await api.get<{ items: Account[]; total: number }>('/api/accounts', { params });
    return r.data;
  },
  create: async (input: Partial<Account> & { workspaceId: string; legalName: string }) => {
    const r = await api.post<Account>('/api/accounts', input);
    return r.data;
  },
  get: async (id: string) => {
    const r = await api.get<Account>(`/api/accounts/${id}`);
    return r.data;
  },
  update: async (id: string, patch: Partial<Account>) => {
    const r = await api.patch<Account>(`/api/accounts/${id}`, patch);
    return r.data;
  },
  remove: async (id: string) => {
    await api.delete(`/api/accounts/${id}`);
  },
  searchSemantic: async (params: { workspaceId: string; q: string; limit?: number }) => {
    const r = await api.get<{ items: (Account & { score: number })[]; semantic: boolean }>(
      '/api/accounts/search/semantic',
      { params },
    );
    return r.data;
  },
  reindex: async (workspaceId: string) => {
    const r = await api.post<{ indexed: number; enabled: boolean }>(
      '/api/accounts/reindex',
      null,
      { params: { workspaceId } },
    );
    return r.data;
  },
};
